import { render } from "./HeaderMenu.vue?vue&type=template&id=5adfda54&scoped=true"
import script from "./HeaderMenu.vue?vue&type=script&lang=ts"
export * from "./HeaderMenu.vue?vue&type=script&lang=ts"

import "./HeaderMenu.vue?vue&type=style&index=0&id=5adfda54&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5adfda54"

export default script